import styles from "./Fragment.module.scss";
import fragmentIcon from "../../icons/fragment.png";
import { FC } from "react";

interface IFragmentProps {
    amount?: number;
    small?: boolean;
}

export const Fragment: FC<IFragmentProps> = ({ amount, small }) => {
    return (
        <span>
            <img className={`${styles.image} ${small ? styles.small : ''}`} src={ fragmentIcon } alt='fragment' />
            { amount &&
                <span className={`${styles.valueLabel} ${small ? styles.small : ''}`}>
                    { amount }
                </span>
            }
        </span>
    );
}